var map = {
	"./bankokbank.png": "ef5d",
	"./gsb.png": "fc05",
	"./kbank.png": "b9e4",
	"./krungsri.png": "5168",
	"./ktb.png": "f816",
	"./lh.png": "4b46",
	"./scb.png": "92d5",
	"./tmb.png": "63ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1334";